import script from "./subLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./subLogin.vue?vue&type=script&setup=true&lang=ts"

import "./subLogin.vue?vue&type=style&index=0&id=7e1637f1&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e1637f1"]])

export default __exports__